export default __webpack_public_path__ + "images/ce06bd823aea8f59d2a67031cf60ac86.png";